




import { Component, Mixins } from "vue-property-decorator";
import { FormatReference } from "../../../domain/format";
import { PreviewedFormatSelectorDialog } from ".";

@Component({
  components: {
    selector: PreviewedFormatSelectorDialog,
  },
})
export default class PreviewedFormatSelectorInstantDialog extends Mixins() {
  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  async show(items: FormatReference[], selectedItem: FormatReference = null): Promise<FormatReference> {
    if (!items || items.length === 0) { return null; }
    const selector = this.$refs.selector as PreviewedFormatSelectorDialog;
    return selector.show(items, selectedItem);
  }
}
